@if (context$ | async; as ctx) {
  <flx-resource-header
    [breadcrumbs]="breadcrumbItems"
    [defaultBackMenuItem]="breadcrumbItems[0]"
  >
    <div
      class="flex flex-row justify-end items-center gap-x-3"
      resourceHeaderRightContent
    >
      <button
        (click)="op.toggle($event)"
        class="p-1 h-6 w-6"
        variant="ghost"
        flxButton
        type="button"
        icon="center"
        data-testId="process-info-button"
      >
        <i
          class="ph ph-info text-sm"
          flxIcon
        ></i>
      </button>
      <button
        [disabled]="!accessRights().canEdit"
        (click)="toggleMenu($event, menu)"
        class="secondary small flx-ds icon-btn"
        flxButton
        icon="center"
        clickStopPropagation
        data-testId="process-instance-menu"
      >
        <i
          class="ph-bold ph-dots-three-vertical leading-4 text-base text-white"
          flxIcon
        ></i>
      </button>
    </div>
  </flx-resource-header>
  <main class="h-full">
    <app-process-instance-react-flow
      [showBreadcrumb]="false"
      [loading]="ctx.loading && applicationDetailsLoaded()"
      [applicationProcessData]="ctx.applicationProcessData"
      [definitionsExist]="definitionsExist()"
      (navigateToSubProcess)="navigateToSubprocess($event)"
      (navigateToEmbeddedProcess)="navigateToSubprocessEmbed($event)"
      (backToParentProcess)="backToParentProcess($event)"
      class="block"
    ></app-process-instance-react-flow>
  </main>
  <p-popover
    #op
    [showTransitionOptions]="'0ms'"
    [hideTransitionOptions]="'0ms'"
    [baseZIndex]="1000"
    appendTo="body"
    styleClass="flx-prime-popover"
  >
    <ng-template #content>
      <div
        [style.width.px]="410"
        class="flex flex-col gap-3"
      >
        <flx-process-instance-info
          [applicationProcessData]="ctx.applicationProcessData"
          [definitionsExist]="definitionsExist()"
          (goToProcessClicked)="goToProcess(ctx.applicationProcessData)"
        ></flx-process-instance-info>
      </div>
    </ng-template>
  </p-popover>
}
<p-menu
  #menu
  [popup]="true"
  [appendTo]="'body'"
  [model]="processInstanceMenuItems"
  styleClass="flx-prime-menu"
/>
